const URL = {
  COURSE_TIME_SERIES_LIST: 'report/courseTimeSeriesByFilter',
}

export default URL
